import React from "react";
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import PrivateRoute from './PrivateRoute'
import Home from '../components/layout/Home/Home'
import Inicio from '../components/layout/Home/Inicio'
import Login from '../components/layout/Login/Login'
import ListadoUsuarios from '../components/layout/Login/ListadoUsuarios'
import Logout from '../components/layout/Login/Logout'
import AuthContextProvider from "./contexts/AuthContext.js";

// Logs
import Logs from './views/Logs/ListadoLogs'

// Clientes
import ListadoClientes from "./views/Clientes/ListadoClientes"

// Catálogos
import BotonesCatalogos from "./views/Catalogos/BotonesCatalogos"
import ListadoEmpresas from "./views/Catalogos/ListadoEmpresas"
import ListadoCategorias from "./views/Catalogos/ListadoCategorias"
import ListadoCuentas from "./views/Catalogos/ListadoCuentas"

// Entradas
import ListadoEntradas from "./views/Entradas/ListadoEntradas"
import EntradasCreate from "./views/Entradas/EntradasCreate"

// Salidas
import ListadoSalidas from "./views/Salidas/ListadoSalidas"
import SalidasCreate from "./views/Salidas/SalidasCreate"

// Estado de Cuenta
import EstadoCuenta from "./views/EstadoCuenta/EstadoCuenta"
import EstadoCuentaInterno from "./views/EstadoCuenta/EstadoCuentaInterno"

function Routes() {
    return (
        <AuthContextProvider>
            <BrowserRouter>
                <Switch>
                    {/* Rutas públicas */}
                    <Route exact path="/" component={Home} />
                    <Route exact path="/Login" component={Login} />
                    <Route exact path="/Logout" component={Logout} />

                    {/* Rutas protegidas */}
                    <PrivateRoute exact path="/Inicio" component={Inicio} />
                    <PrivateRoute exact path="/ListadoUsuarios" component={ListadoUsuarios} />
                    <PrivateRoute exact path="/MenuLogs" component={Logs} />

                    {/* Clientes */}
                    <PrivateRoute exact path="/ListadoClientes" component={ListadoClientes} />

                    {/* Catálogos */}
                    <PrivateRoute exact path="/MenuCatalogos" component={BotonesCatalogos} />
                    <PrivateRoute exact path="/ListadoEmpresas" component={ListadoEmpresas} />
                    <PrivateRoute exact path="/ListadoCategorias" component={ListadoCategorias} />
                    <PrivateRoute exact path="/ListadoCuentas" component={ListadoCuentas} />

                    {/* Entradas */}
                    <PrivateRoute exact path="/ListadoEntradas" component={ListadoEntradas} />
                    <PrivateRoute exact path="/EntradasCreate" component={EntradasCreate} />

                    {/* Salidas */}
                    <PrivateRoute exact path="/ListadoSalidas" component={ListadoSalidas} />
                    <PrivateRoute exact path="/SalidasCreate" component={SalidasCreate} />

                    {/* Estado de Cuenta */}
                    <PrivateRoute exact path="/EstadoCuenta" component={EstadoCuenta} />
                    <PrivateRoute exact path="/EstadoCuentaInterno" component={EstadoCuentaInterno} />
                </Switch>
            </BrowserRouter>
        </AuthContextProvider>
    );
}

export default Routes
